import setPagesInNavigation from './set-pages-in-navigation';
import setMultilingual from './set-multilingual';
import createPageFromTemplate from './create-page-from-template';
import setActivePage from './set-active-page';
import reloadSiteMeta from './reload-site-meta';

export default {
  setPagesInNavigation,
  setMultilingual,
  createPageFromTemplate,
  setActivePage,
  reloadSiteMeta,
};
